import { render, staticRenderFns } from "./SmsIndex.vue?vue&type=template&id=5cd65dd7&scoped=true"
import script from "./SmsIndex.vue?vue&type=script&lang=js"
export * from "./SmsIndex.vue?vue&type=script&lang=js"
import style0 from "./SmsIndex.vue?vue&type=style&index=0&id=5cd65dd7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd65dd7",
  null
  
)

export default component.exports